import AddTransaction from "../components/AddTransaction";
import TransactionList from "../components/TransactionList";
import Login from "../components/Login";
import Dashboard from "../components/Dashboard";
import Footer from "../components/Footer";

function Home() {
  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#020617] via-[#020617] to-[#0B1120] px-4 sm:px-6 lg:px-8 py-8">
      
      <div className="max-w-7xl mx-auto w-full">

        {/* Header */}
        <div className="text-center mb-10">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
           Expense Analyzer
          </h1>
          <p className="text-slate-400 mt-2 text-sm">
            Smart insights for your money
          </p>
        </div>

        {/* Login */}
        <div className="mb-6 bg-[#111827]/80 backdrop-blur-md rounded-2xl p-4 shadow-xl border border-slate-700/50">
          <Login />
        </div>

        {/* Dashboard */}
        <div className="mb-6">
          <Dashboard />
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

          {/* Add Transaction */}
          <div className="bg-[#111827]/80 backdrop-blur-md rounded-2xl p-4 shadow-xl border border-slate-700/50 hover:border-green-500/30 transition">
            <AddTransaction />
          </div>

          {/* Transaction List */}
          <div className="lg:col-span-2 bg-[#111827]/80 backdrop-blur-md rounded-2xl p-4 shadow-xl border border-slate-700/50 hover:border-green-500/30 transition">
            <TransactionList />
          </div>

        </div>

        {/* Footer */}
        <Footer />

      </div>
    </div>
  );
}

export default Home;